import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import Filter from './Filter.js';
import Box from '../Box.js';
import Loadable from '../loading/Loadable.js';


import './Filterable.scss';

const Filterable = (props) => {
	const urlParams = new URLSearchParams(window.location.search);
	const [filter, setFilter] = useState(urlParams.get('q') || '');
	const [addInterfaceOpen, setAddInterfaceOpen] = useState(false);

	
	const addItem = (e) => {
		e.preventDefault();
		setAddInterfaceOpen(true);
	}
	
	const closeAddInterface = (e) => {
		setAddInterfaceOpen(false);
	}
	
	const onAdded = async (e) => {
		if (props.onAddSubmit) {
			let r = await props.onAddSubmit(e);
			if (r)
				closeAddInterface();
		}
	}
	
	const onSubmit = (e) => {
		e.preventDefault();
		if (props.children) {
			const children = applyfilter(props.children, filter);
			if (children.length === 1) {
				if (props.onSelect) props.onSelect(children[0]);
			} else {
				addItem(e);
			}
		}
	}
	
	const filterChange = (e) => {
		setFilter(e.target.value);
	}
	

	
	const _filter = (data, filterstring) => {
		let filtered = [];
		const f = filterstring.toLowerCase();
		for(let i in data) {
			for(let prop in data[i]) {
				if ((typeof data[i][prop] === 'string' || data[i][prop] instanceof String) && data[i][prop].toLowerCase().includes(f)) {
					filtered.push(data[i])
					break;
				}
			}
		}
		return filtered;
	}
	
	const applyfilter = (data, filterstring) => {
		if (props.filter)
			return props.filter(data, filterstring);
		return _filter(data, filterstring);
	}
	
	
	let children = "";
	if (props.children) {
		const data = applyfilter(props.children, filter);
		children = [];
		for(let i=0; i < data.length; i++) {
			children.push(React.createElement(props.summaryComponent, {key: i, ...data[i], ...props.passProps}));
		}
		
		if (children.length === 0)
			children = <p>None found.</p>;
	}
	
	const addInterface = props.onAddSubmit !== false ? React.createElement(props.addForm, {filter: filter, onAdded: onAdded, ...props.addProps}) : null;


	const Wrapper = props.wrapper && children.length > 0 ? props.wrapper : (props) => {
		return <React.Fragment>{children}</React.Fragment>;
	}


	return (
		<div className={(props.className || '') + ' Filterable'}>
			<div className="filteradd">
				<Filter filter={null} value={filter} name="filter" placeholder={props.placeholder | 'Filter...'} onChange={filterChange} onSubmit={onSubmit} />
				{ props.onAddSubmit !== false &&
					<button className="block plus" title="Add a new farm" onClick={addItem}>
						<FontAwesomeIcon icon={faPlus}/>
					</button>
				}
			</div>
			<Box 
				modal={true}
				isOpen={addInterfaceOpen}
				onRequestClose={closeAddInterface}
				title={"Add a new " + props.type}
			>
				{addInterface}
			</Box>
			<Loadable className="members" ready={props.children !== false}>
				{React.createElement(Wrapper, {}, children)}
			</Loadable>
	
		</div>);

}

export default Filterable;